"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * RichWise_Website_API.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfProductColorStyleEditModel = instanceOfProductColorStyleEditModel;
exports.ProductColorStyleEditModelFromJSON = ProductColorStyleEditModelFromJSON;
exports.ProductColorStyleEditModelFromJSONTyped = ProductColorStyleEditModelFromJSONTyped;
exports.ProductColorStyleEditModelToJSON = ProductColorStyleEditModelToJSON;
exports.ProductColorStyleEditModelToJSONTyped = ProductColorStyleEditModelToJSONTyped;
/**
 * Check if a given object implements the ProductColorStyleEditModel interface.
 */
function instanceOfProductColorStyleEditModel(value) {
    return true;
}
function ProductColorStyleEditModelFromJSON(json) {
    return ProductColorStyleEditModelFromJSONTyped(json, false);
}
function ProductColorStyleEditModelFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'pcsColorStyleNo': json['pcsColorStyleNo'] == null ? undefined : json['pcsColorStyleNo'],
        'pcsColorStyleName': json['pcsColorStyleName'] == null ? undefined : json['pcsColorStyleName'],
        'pcsRemark': json['pcsRemark'] == null ? undefined : json['pcsRemark'],
        'pcsUseStatus': json['pcsUseStatus'] == null ? undefined : json['pcsUseStatus'],
    };
}
function ProductColorStyleEditModelToJSON(json) {
    return ProductColorStyleEditModelToJSONTyped(json, false);
}
function ProductColorStyleEditModelToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'pcsColorStyleNo': value['pcsColorStyleNo'],
        'pcsColorStyleName': value['pcsColorStyleName'],
        'pcsRemark': value['pcsRemark'],
        'pcsUseStatus': value['pcsUseStatus'],
    };
}
